var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 97.419,
    height: 93.476,
    viewBox: "0 0 97.419 93.476",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#efefef",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#efefef",
    stopOpacity: 0.102
  })), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    x: 0,
    y: 5.39,
    width: 97.419,
    height: 81.558,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "c"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffe8b9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "c"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "d",
    x: 23.477,
    y: 26.409,
    width: 50.436,
    height: 48.151,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "e"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffe8b9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "e"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.281)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)",
    stroke: "#fff8ea",
    strokeWidth: 2,
    fill: "url(#a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 46.738,
    cy: 46.738,
    r: 46.738,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.738,
    cy: 46.738,
    r: 45.738,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.719 20.39)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -15, -20.39)",
    filter: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M789.094-334.483q-15.058,0-30.114,0a3.378,3.378,0,0,1-3.544-2.872,3.378,3.378,0,0,1,3.114-3.9c1.043-.032,2.089-.021,3.13-.006a.532.532,0,0,0,.621-.493,7.612,7.612,0,0,1,3.856-5.224.815.815,0,0,0,.467-.815c-.012-3.805-.006-7.612-.011-11.419,0-.163.087-.391-.073-.476-.2-.1-.33.131-.473.235q-1.469,1.074-2.924,2.17a1.357,1.357,0,0,1-1.524.286,1.337,1.337,0,0,1-.658-1.35c0-1.249.009-2.5-.006-3.749a1.85,1.85,0,0,1,.835-1.629q11.859-8.835,23.695-17.706c.9-.669,1.784-1.35,2.682-2.017a1.217,1.217,0,0,1,1.836,0q3.691,2.758,7.375,5.525c.156.116.309.376.52.249.152-.092.055-.353.069-.539.006-.095,0-.189,0-.284,0-.744,0-.744-.759-.756-1.026-.014-1.436-.428-1.44-1.461q-.007-1.961,0-3.922c0-.979.408-1.4,1.374-1.4q7.657,0,15.314,0a1.194,1.194,0,0,1,1.367,1.359q.014,2.016,0,4.033c-.008.933-.468,1.37-1.419,1.388-.844.017-.846.017-.846.881,0,3.5.006,7.007-.008,10.511a.989.989,0,0,0,.445.9c1.487,1.081,2.944,2.205,4.44,3.276a1.709,1.709,0,0,1,.776,1.484c0,1.287.009,2.576,0,3.863a1.323,1.323,0,0,1-.745,1.356,1.354,1.354,0,0,1-1.464-.322c-1-.756-2.006-1.5-3.013-2.24-.1-.076-.2-.22-.34-.16s-.087.235-.087.359q0,5.823-.008,11.647a.694.694,0,0,0,.4.679,7.67,7.67,0,0,1,3.928,5.3.505.505,0,0,0,.595.453c.949-.014,1.9-.009,2.846,0a3.406,3.406,0,0,1,3.484,3.384,3.436,3.436,0,0,1-3.481,3.395Q804.21-334.477,789.094-334.483Zm-20.129-20.381v5.965c0,.941,0,.941.961.872a1.929,1.929,0,0,1,.283,0,7.949,7.949,0,0,1,6.531,3.761c.2.313.3.328.578.073a5.638,5.638,0,0,1,9.335,2.478.549.549,0,0,0,.6.455q6.289-.014,12.578,0c.383,0,.529-.154.608-.508a7.64,7.64,0,0,1,3.81-5.194,31.6,31.6,0,0,1,3.4-1.019,2.252,2.252,0,0,1,.9-.015c.491.116.669-.061.665-.58q-.025-6.278,0-12.554a.9.9,0,0,0-.412-.8q-9.637-7.2-19.256-14.422a.652.652,0,0,0-.936.012q-9.6,7.206-19.211,14.385a.994.994,0,0,0-.441.9C768.973-358.993,768.964-356.928,768.964-354.865Zm20.1,18.036h29.99a1.406,1.406,0,0,0,.777-.11,1.025,1.025,0,0,0,.517-1.209.962.962,0,0,0-.994-.774c-1.366-.009-2.731,0-4.1-.009-1.112-.006-1.541-.421-1.6-1.535a5.468,5.468,0,0,0-5.465-5.166,5.48,5.48,0,0,0-5.544,5.084c-.078,1.24-.468,1.617-1.694,1.617q-7.4,0-14.8,0c-1.181,0-1.551-.353-1.664-1.522a3.043,3.043,0,0,0-1.126-2.155,3.2,3.2,0,0,0-3.363-.536,3.143,3.143,0,0,0-2.053,2.883,1.27,1.27,0,0,1-1.217,1.319c-.641,0-1.1-.489-1.193-1.283-.014-.113-.017-.226-.023-.34a5.471,5.471,0,0,0-5.559-5.067,5.477,5.477,0,0,0-5.448,5.125c-.058,1.18-.471,1.571-1.669,1.576-1.347,0-2.695-.006-4.041.012a1,1,0,0,0-1,.835,1.051,1.051,0,0,0,.6,1.174,1.78,1.78,0,0,0,.84.081Zm25.726-24.418c.136-.548-.185-.832-.575-1.124q-12.251-9.158-24.482-18.345a.91.91,0,0,0-1.318.025q-12.162,9.14-24.36,18.227a1.62,1.62,0,0,0-.681,1.643c.025.315.154.3.358.147l.364-.27q11.882-8.9,23.765-17.79c1.135-.85,1.316-.852,2.436-.012q11.9,8.913,23.812,17.819c.185.139.366.446.607.315C814.909-360.718,814.766-361.034,814.789-361.246Zm-5.666-7.919a.984.984,0,0,0,.076-.218c0-3.143,0-6.285.011-9.427,0-.414-.227-.449-.548-.447-2.58,0-5.159.011-7.737,0-.435,0-.56.163-.551.57.021.814.026,1.628,0,2.442a1.027,1.027,0,0,0,.485.945c2.254,1.669,4.5,3.357,6.741,5.036C808.094-369.9,808.6-369.546,809.124-369.166ZM804.763-381.6h5.348c1.371,0,1.343,0,1.38-1.383.015-.583-.173-.734-.742-.732-3.716.023-7.433.012-11.149.012-1.507,0-1.489,0-1.493,1.5,0,.479.165.614.627.609C800.743-381.613,802.753-381.6,804.763-381.6Z",
    transform: "translate(-740.38 406.43)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -15, -20.39)",
    filter: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M776.705-372.129a5.518,5.518,0,0,1,3.955,1.836c.212.224.324.349.614.051a5.6,5.6,0,0,1,7.783-.578,6.044,6.044,0,0,1,1,8.152,8.353,8.353,0,0,1-.826.947q-3.534,3.545-7.078,7.078c-.887.884-1.439.886-2.324,0-2.414-2.411-4.839-4.813-7.237-7.241a6,6,0,0,1,.161-8.774A5.577,5.577,0,0,1,776.705-372.129Zm12.065,6.1a3.423,3.423,0,0,0-2.027-3.446,3.239,3.239,0,0,0-3.786.9,3.881,3.881,0,0,0-.8,2.217,1.176,1.176,0,0,1-1.195,1.084,1.2,1.2,0,0,1-1.146-1.078c-.038-.244-.061-.492-.109-.733a3.149,3.149,0,0,0-2.088-2.45,3.031,3.031,0,0,0-3.208.578,3.643,3.643,0,0,0-.094,5.427c2.084,2.124,4.207,4.206,6.3,6.319.28.281.451.288.734,0,2.094-2.113,4.206-4.207,6.306-6.314A3.365,3.365,0,0,0,788.771-366.025Z",
    transform: "translate(-732.28 413.54)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.4efdd0a1f718363efa30aa51757f4224.svg";
export { ForwardRef as ReactComponent };